import AttendanceManagement from './AttendanceManagement';
import AttendanceLog from './attendance-log/AttendanceLog';

const AttendanceManagementConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/attendanceManagement',
            element: <AttendanceManagement />,
        },
        {
            path: '/attendanceManagement/attendance-log',
            element: <AttendanceLog />,
        },
       
    ],
};

export default AttendanceManagementConfig;
